import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cyq0jgl0zz: FaireBrandEntity = {
  token: "b_cyq0jgl0zz",
  type: "brand",
  name: "Savvy Bling",
  avatarUrl:
    "https://cdn.faire.com/fastly/491802fe9357f838ec0f616d9872bbfc3cb3060e55faf658e4fc9f21bb685622.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/445d1b57c279769e6110587777ea350468ddc285598bb9bf1867fb37af2ee422.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/491802fe9357f838ec0f616d9872bbfc3cb3060e55faf658e4fc9f21bb685622.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/445d1b57c279769e6110587777ea350468ddc285598bb9bf1867fb37af2ee422.jpeg",
  location: "Parsons, KS, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 461,
  isTopShop: true,
  isInsider: true,
  description: "",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:22.252Z",
    importedBy: "entity-db-cli",
  },
};
